import React from "react"

import "./prize-section.style.scss"

import FirstPrize from '../../../assets/img/award_1.svg'
import SecondPrize from '../../../assets/img/award_2.svg'
import ThirdPrize from '../../../assets/img/award_3.svg'
import FourthPrize from '../../../assets/img/award_4.svg'
import FifthPrize from '../../../assets/img/award_5.svg'

const Prizes = () => {
  return (
    <section className="flex justify-center items-center container py-20">
      <div className="max-w-[736px] bg-white p-6 rounded-lg ">
        <h3 className="text-center text-secondary text-xl font-bold mb-4">ΒΡΑΒΕΙΑ</h3>
        <p className="mb-4 text-center max-w-[550px] mx-auto">Τα 5 καλύτερα, σύμφωνα με την Κριτική Επιτροπή, έργα βραβεύτηκαν
          με το συνολικό χρηματικό ποσό των <span className="font-bold">€20.000</span> </p>
        <div className="grid md:grid-cols-5 p-[40px] justify-items-center gap-4 mb-8">
          <div className="prize-item place-self-center md:col-span-1 col-span-5">
            <img src={FirstPrize} alt="First Prize" />
            <p className="font-bold text-[24px]">€8.000</p>
          </div>
          <div className="prize-item md:place-self-center place-self-end md:col-span-1 col-span-2">
            <img src={SecondPrize} alt="Second Prize" />
            <p className="font-bold text-[24px]">€5.000</p>
          </div>
          <div className="prize-item md:place-self-center place-self-start col-start-4  md:col-span-1 col-span-2">
            <img src={ThirdPrize} alt="First Prize" />
            <p className="font-bold text-[24px]">€3.000</p>
          </div>
          <div className="prize-item md:place-self-center place-self-start md:col-span-1 col-span-2">
            <img src={FourthPrize} alt="First Prize" />
            <p className="font-bold text-[24px]">€2.000</p>
          </div>
          <div className="prize-item md:place-self-center place-self-end col-start-4 md:col-span-1 col-span-2">
            <img src={FifthPrize} alt="First Prize" />
            <p className="font-bold text-[24px]">€2.000</p>
          </div>
        </div>
        <p className="text-center text-base">Τα προκρινόμενα 32 έργα εκτίθενται από 9 έως 27 Φεβρουαρίου στο Ιστορικό Εργοστάσιο της ΔΕΗ και κυκλοφορούν σε κατάλογο.</p>
      </div>
    </section>
  )
}

export default Prizes
